module.exports = __webpack_public_path__ + "media/components/assets/img/bg/torp-airport-a5fb501b6f7b2691dde979fb0fac5975.svg";